import { ChevronDown } from "lucide-react";
import type React from "react";

interface NavGroupProps {
  title: string;
  icon: React.ReactNode;
  iconColor: string;
  children: React.ReactNode;
  isOpen?: boolean;
  onToggle?: () => void;
}

const NavGroup: React.FC<NavGroupProps> = ({
  title,
  icon,
  iconColor,
  children,
  isOpen = false,
  onToggle = () => {},
}) => {
  return (
    <div className="mb-3">
      <button
        onClick={onToggle}
        className="flex w-full items-center justify-between px-6 py-3 text-sm font-medium text-gray-700 hover:text-gray-800 rounded-tr-lg rounded-br-lg mx-3 transition-all duration-300"
      >
        <div className="flex items-center">
          <span className={`mr-3 p-2 rounded-full ${iconColor}`}>{icon}</span>
          {title}
        </div>
        <ChevronDown
          size={16}
          className={`text-gray-500 transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out pl-2 ${
          isOpen ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default NavGroup;
